import script from "./intros-config-table.vue?vue&type=script&setup=true&lang=js"
export * from "./intros-config-table.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__